import { render, staticRenderFns } from "./ConnectButton.vue?vue&type=template&id=513b74b1&scoped=true&"
import script from "./ConnectButton.vue?vue&type=script&lang=ts&"
export * from "./ConnectButton.vue?vue&type=script&lang=ts&"
import style0 from "./ConnectButton.vue?vue&type=style&index=0&id=513b74b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513b74b1",
  null
  
)

export default component.exports